import React, { useMemo, useState } from "react";

// Utils
import { Form, FormGroup, Dropdown } from "semantic-ui-react";

// Common
import DateTextBox from "react-lib/apps/common/DateTextBox";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { useIntl } from "react-intl";

const CardDoctorIncomeMonthlySummaryFilter = (props: any) => {
  const intl = useIntl();
  // useState
  const [requiredStartDate, setRequiredStartDate] = useState<boolean>(false);

  // useMemo
  const doctorOptions = useMemo(() => {
    return [
      { key: "ALL", value: "ALL", text: "แพทย์ทั้งหมด" },
      ...(props.masterOptions?.doctor || []),
    ];
  }, [props.masterOptions?.doctor]);

  // const divisionOptions = useMemo(() => {
  //   return [
  //     { key: "ALL", value: "ALL", text: "ทุกสาขา" },
  //     ...(props.masterOptions?.division || []),
  //   ];
  // }, [props.masterOptions?.division]);

  const specialtyOptions = useMemo(() => {
    return [
      { key: "ALL", value: "ALL", text: "ทุกสาขา" },
      ...(props.masterOptions?.specialty || []),
    ];
  }, [props.masterOptions?.specialty]);

  const handlePreviewButton = () => {
    if (requiredStartDate) {
      alert("กรุณาระบุวันที่รับบริการ");
    } else {
      props.runSequence({
        sequence: "ClinicAnnualReport",
        action: "PREVIEW_REPORT",
        menu: "รายงานสรุปรายได้ทั้งเดือนส่งเบิกจ่ายแพทย์",
      });
    }
  };

  const handlePrintButton = () => {
    if (requiredStartDate) {
      alert("กรุณาระบุวันที่รับบริการ");
    } else {
      props.runSequence({
        sequence: "ClinicAnnualReport",
        action: "PRINT_REPORT",
        menu: "รายงานสรุปรายได้ทั้งเดือนส่งเบิกจ่ายแพทย์",
      });
    }
  };

  const handleDownloadButton = () => {
    if (requiredStartDate) {
      alert("กรุณาระบุวันที่รับบริการ");
    } else {
      props.runSequence({
        sequence: "ClinicAnnualReport",
        action: "DOWNLOAD_REPORT",
        menu: "รายงานสรุปรายได้ทั้งเดือนส่งเบิกจ่ายแพทย์",
      });
    }
  };

  return (
    <Form>
      <FormGroup className="ui form" style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label style={{ display: "flex", alignItems: "center", padding: "0rem 0.5rem 0rem 0rem" }}>
          วันที่รับบริการ<span style={{ color: "red" }}>*</span>
        </label>
        <DateTextBox
          onChange={(date: string) => {
            props.setProp(
              `ClinicAnnualReportSequence.doctorIncomeMonthlySummaryReport.filterStartDate`,
              date
            )
            if (props.ClinicAnnualReportSequence?.doctorIncomeMonthlySummaryReport?.filterStartDate.length < 1) {
              setRequiredStartDate(true);
            } else {
              setRequiredStartDate(false);
            }
          }}
          style={{ width: "11rem" }}
          value={
            props.ClinicAnnualReportSequence?.doctorIncomeMonthlySummaryReport?.filterStartDate ||
            ""
          }
        ></DateTextBox>
        <label style={{ display: "flex", alignItems: "center" }}>{intl.formatMessage({ id: "ถึง" })}</label>
        <DateTextBox
          onChange={(date: string) =>
            props.setProp(
              `ClinicAnnualReportSequence.doctorIncomeMonthlySummaryReport.filterEndDate`,
              date
            )
          }
          style={{ width: "11rem" }}
          value={
            props.ClinicAnnualReportSequence?.doctorIncomeMonthlySummaryReport?.filterEndDate || ""
          }
        ></DateTextBox>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 1rem 0rem 0rem",
          }}
        ></label>
        <ButtonLoadCheck
          setProp={props.setProp}
          onClick={handlePreviewButton}
          paramKey={`ClinicAnnualReport_PREVIEW_REPORT`}
          buttonLoadCheck={props.buttonLoadCheck?.[`ClinicAnnualReport_PREVIEW_REPORT`]}
          color="yellow"
          style={{ width: "11rem" }}
          title="Preview"
        />
      </FormGroup>
      <FormGroup className="ui form" style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 4.3rem 0rem 0rem",
          }}
        >
          แพทย์
        </label>
        <Dropdown
          value={
            props.ClinicAnnualReportSequence?.doctorIncomeMonthlySummaryReport?.doctorSelected || ""
          }
          onChange={(e: any, data: any) =>
            props.setProp(
              `ClinicAnnualReportSequence.doctorIncomeMonthlySummaryReport.doctorSelected`,
              data.value
            )
          }
          placeholder={intl.formatMessage({ id: "เลือกแพทย์" })}
          options={doctorOptions}
          search={true}
          selection={true}
          style={{ minWidth: "20rem" }}
        ></Dropdown>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 6.1rem 0rem 0rem",
          }}
        ></label>
        <ButtonLoadCheck
          setProp={props.setProp}
          onClick={handlePrintButton}
          paramKey={`ClinicAnnualReport_PRINT_REPORT`}
          buttonLoadCheck={props.buttonLoadCheck?.[`ClinicAnnualReport_PRINT_REPORT`]}
          color="blue"
          style={{ width: "11rem" }}
          title={intl.formatMessage({ id: "พิมพ์" })}
        />
      </FormGroup>
      <FormGroup className="ui form" style={{ gap: "1rem", padding: "0rem 0rem 0rem 1rem" }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 1.9rem 0rem 0rem",
          }}
        >
          สาขาแพทย์
        </label>
        <Dropdown
          value={
            props.ClinicAnnualReportSequence?.doctorIncomeMonthlySummaryReport?.specialtySelected ||
            ""
          }
          onChange={(e: any, data: any) =>
            props.setProp(
              `ClinicAnnualReportSequence.doctorIncomeMonthlySummaryReport.specialtySelected`,
              data.value
            )
          }
          placeholder={intl.formatMessage({ id: "เลือกสาขาแพทย์" })}
          options={specialtyOptions}
          search={true}
          selection={true}
          style={{ minWidth: "15.5rem" }}
        ></Dropdown>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0rem 10.55rem 0rem 0rem",
          }}
        ></label>
        <ButtonLoadCheck
          setProp={props.setProp}
          onClick={handleDownloadButton}
          paramKey={`ClinicAnnualReport_DOWNLOAD_REPORT`}
          buttonLoadCheck={props.buttonLoadCheck?.[`ClinicAnnualReport_DOWNLOAD_REPORT`]}
          color="green"
          style={{ width: "11rem" }}
          title={intl.formatMessage({ id: "ดาวน์โหลด xlsx" })}
        />
      </FormGroup>
    </Form>
  );
};

export default CardDoctorIncomeMonthlySummaryFilter;
